import LoadImgs from './loadImgs';
import webpUrl from './webpUrl';
import { utils as coreUtils } from '@didi/webx-js-core';
import PageShow from './pageShow';
import { setEncrypt } from './encrypt';
import { getBottomNavHeight } from './getBottomNavHeight';
import { is } from '../xenv';
import { weixinReady } from '../platform/xenv/_common/weixin';
import { getEncryptPublicKey } from './encrypt/get_public_key';
const pageShow = new PageShow();
/**
 * 重置字体大小，防止在微信 h5 和微信小程序内嵌 h5 中字体大小随微信设置中的字体大小变化而变化
 */
const resetFontSize = () => {
    if (is('weixin')) {
        if (is('ios')) {
            const resetFontSizeStyleDom = document.createElement('style');
            resetFontSizeStyleDom.innerHTML = `body {
        -webkit-text-size-adjust: 100% !important;
        text-size-adjust: 100% !important;
      }`;
            document.body.insertBefore(resetFontSizeStyleDom, document.body.firstChild);
        }
        weixinReady(wx => {
            wx?.invoke?.('setFontSizeCallback', { 'fontSize': 2 });
            // 重写设置网页字体大小的事件
            wx?.on?.('menu:setfont', function () {
                wx?.invoke?.('setFontSizeCallback', { 'fontSize': 2 });
            });
        });
    }
};
const copy = (text) => {
    try {
        const input = document.createElement('textarea');
        input.readOnly = true;
        input.style.opacity = '0';
        input.value = text;
        document.body.appendChild(input);
        input.select();
        input.setSelectionRange(0, input.value.length);
        const copyRes = document.execCommand('Copy') || document.execCommand('copy');
        document.body.removeChild(input);
        return copyRes ? Promise.resolve() : Promise.reject();
    }
    catch (e) {
        return Promise.reject();
    }
};
/**
 * 根据key名查询cookie中的值
 */
const getCookie = (name) => {
    if (!document)
        return '';
    const cookieArr = document?.cookie?.split(';') || []; // 将所有cookie分割成数组
    const cookieDict = cookieArr.reduce((pre, cur) => {
        const arr = cur?.split('=') || [];
        return Object.assign(pre, {
            [arr[0]?.trim()]: arr[1]?.trim()
        });
    }, {});
    return cookieDict[name] || '';
};
/**
 * check是否为预览并添加预览标识
 */
const handleMockviewTag = (header, curDchn) => {
    if (curDchn) {
        const mockDchn = getCookie('chitu_mockview_dchn');
        if (mockDchn && mockDchn === curDchn)
            header['Chitu-Header-Mockview'] = 1;
        else
            delete header['Chitu-Header-Mockview'];
    }
};
const utils = {
    ...coreUtils,
    setEncrypt,
    getEncryptPublicKey,
    resetFontSize,
    LoadImgs,
    webpUrl,
    copy,
    pageShow,
    getCookie,
    getBottomNavHeight,
    handleMockviewTag
};
export { utils };
